export default __webpack_public_path__ + "5b39389da3b7b57fdfbae166213b73ad.png";